module.exports = __webpack_public_path__ + "img/ic-search.2dd6cbd6.svg";